import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AdminAuthService } from '../../components/admin/service/admin-auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PlatformAdminGuard implements CanActivate {

    constructor(
        private auth: AdminAuthService,
        private router: Router
    ) { }

    canActivate() {
        return this.auth.platformAdmin$.pipe(
            take(1),
            map(isAdmin => {
                if (!isAdmin) {
                    this.router.navigate(['/admin/home']);
                    return false;
                }
                return true;
            })
        );
    }
}
